<template>
  <div>
    <iframe src="" frameborder="0" ref="iframe" class="print-iframe"></iframe>

    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-select :options="productOption" v-model:value="requestPayload.productName" placeholder="产品名称" allowClear
          @change="handleSearch" style="width: 140px">
        </a-select>

        <!-- <a-date-picker
          v-model:value="requestPayload.startDate"
          placeholder="开始日期"
          allowClear
          @change="handleSearch"
        >
        </a-date-picker>

        <a-date-picker
          v-model:value="requestPayload.endDate"
          placeholder="结束时间"
          allowClear
          @change="handleSearch"
        >
        </a-date-picker> -->

        <a-range-picker v-model:value="rangeDate" @change="handleSelectRangeDate" allowClear />

        <a-date-picker v-model:value="requestPayload.produceDate" placeholder="生产时间" allowClear
          @change="handleSelectDate">
        </a-date-picker>
      </a-space>

      <a-space>
        <a-button @click="handleInsertInstruction(key)" type="primary">新增</a-button>
        <!-- <a-button
          @click="handleBatchPrint"
          :disabled="selectedRowKeys.length === 0"
        >
          批量打印
        </a-button> -->
      </a-space>
    </div>

    <div class="product-instruction-table">
      <a-table :data-source="tableData" bordered :pagination="false" :columns="columns" rowKey="id"
        :scroll="{ x: 'calc(100vw - 180px)', y: 'calc(100vh - 300px)' }">
        <template #productName="{ record }">
          {{ getProcessName(record.productName) }}
        </template>

        <template #productNumberList="{ record }">
          <!-- <div v-for="(item, index) in record.pqcList" :key="index">
            {{ item.snNumber }}
          </div> -->
          <select-subordinate :produceOrTpc="produceOrTpc" :superior="record">
          </select-subordinate>
        </template>

        <template #action="{ record }">
          <a-dropdown>
            <template #overlay>
              <a-menu @click="handleActionClick($event, record)">
                <a-menu-item key="edit">修改</a-menu-item>
                <a-menu-item key="print">打印</a-menu-item>
              </a-menu>
            </template>
            <a-button size="small" type="primary">
              操作
              <DownOutlined />
            </a-button>
          </a-dropdown>

          <!-- <a-space>
            <a-button
              type="primary"
              @click="handleInsertInstruction(key, record)"
              size="small"
              >修改</a-button
            >
            <a-button @click="handlePrintInstruction(record)" size="small">
              打印
            </a-button>
          </a-space> -->
        </template>
      </a-table>
    </div>

    <instruction-form ref="instructionRef" @updateTable="updateTable" :produceOrTpc="produceOrTpc"></instruction-form>
  </div>
</template>

<script>
import { defineComponent, inject, reactive, ref, watch } from "vue";
import { getProductionInstructionList } from "@/request/view/productionInstruction";
import { DownOutlined } from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";

import { productOption } from "@/views/productDaily/components/instruction/option";
import { getProcessName } from "@/views/productDaily/serve/option";
import instructionForm from "@/views/productDaily/components/instruction/form.vue";
import { timeStampToTime } from "@/utils";

import selectSubordinate from "@/views/productDaily/components/instruction/compnents/selectSubordinate.vue";

export default defineComponent({
  components: {
    instructionForm,
    DownOutlined,
    selectSubordinate,
  },
  setup() {
    const instructionRef = ref();
    const iframe = ref();
    const rangeDate = ref(null);

    const selectedRowKeys = ref([]);

    // 生产中心/试产中心
    const produceOrTpc = inject('produceOrTpc', null);

    const route = useRoute();

    const requestPayload = reactive({
      startDate: null,
      endDate: null,
      produceDate: timeStampToTime("", "upload"),
      produceOrTpc,
      productName: null,
    });

    const columns = [
      {
        title: "产品名称",
        width: "140px",
        align: "center",
        fixed: "left",
        slots: {
          customRender: "productName",
        },
      },
      {
        title: "生产批号",
        dataIndex: "batchNumber",
        align: "center",
        width: "140px",
        fixed: "left",
      },
      {
        title: "产品编号/下级编号",
        dataIndex: "productNumberList",
        align: "center",
        fixed: "left",
        width: "520px",
        slots: {
          customRender: "productNumberList",
        },
      },
      {
        title: "型号规格",
        dataIndex: "modelSpecifications",
        align: "center",
        width: "160px",
      },
      {
        title: "单位",
        dataIndex: "unit",
        align: "center",
        width: "80px",
      },
      {
        title: "数量",
        dataIndex: "number",
        align: "center",
        width: "80px",
      },
      {
        title: "生产日期",
        dataIndex: "produceDate",
        align: "center",
        width: "120px",
      },
      {
        title: "完成时间",
        dataIndex: "finishDate",
        align: "center",
        width: "120px",
      },
      {
        title: "编制日期",
        dataIndex: "writeDate",
        align: "center",
        width: "120px",
      },
      {
        title: "编制人",
        dataIndex: "writer",
        align: "center",
        width: "100px",
      },
      {
        title: "审核日期",
        dataIndex: "reviewDate",
        align: "center",
        width: "120px",
      },
      {
        title: "审核人",
        dataIndex: "reviewer",
        align: "center",
        width: "100px",
      },
      {
        title: "批准时间",
        dataIndex: "approveDate",
        align: "center",
        width: "120px",
      },
      {
        title: "批准人",
        dataIndex: "approver",
        align: "center",
        width: "100px",
      },
      {
        title: "领料时间",
        dataIndex: "pickDate",
        align: "center",
        width: "120px",
      },
      {
        title: "领料人",
        dataIndex: "picker",
        align: "center",
        width: "100px",
      },
      {
        title: "操作",
        align: "center",
        width: "100px",
        slots: {
          customRender: "action",
        },
        fixed: "right",
      },
    ];

    // 表格数据
    const tableData = reactive([]);

    const getInstruction = () => {
      return new Promise((resolve, reject) => {
        getProductionInstructionList(requestPayload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject();
          });
      });
    };

    const getData = async () => {
      tableData.length = 0;

      const data = await getInstruction();

      if (data) {
        Object.keys(data).forEach((key) => {
          const list = data[key];
          tableData.push(...list);
        });
      }
    };

    const handleInsertInstruction = (productName, data) => {
      const type = data ? "update" : "insert";
      const title = data ? "更新生产指令单" : "新增生产指令单";
      instructionRef.value.showModal({
        title,
        type,
        productName,
        data,
      });
    };

    const handleSelectRow = (key, row) => {
      selectedRowKeys.value.length = 0;
      selectedRowKeys.value.push(...key);
    };

    const handleSelectRangeDate = (e, stringTime) => {
      const [startDate, endDate] = stringTime;

      requestPayload.startDate = startDate;
      requestPayload.endDate = endDate;

      if (requestPayload.startDate && requestPayload.endDate) {
        requestPayload.produceDate = null;
      }
      getData();
    };

    const handleSelectDate = (e, stringTime) => {
      requestPayload.produceDate = stringTime;
      requestPayload.startDate = null;
      requestPayload.endDate = null;
      getData();
    };

    const handleSearch = () => {
      getData();
    };

    // 打印
    const toPrint = () => {
      iframe.value.style.display = "block";
      const serverUrl = `${window.location.origin}/QC/index.html#/printInstruction`;
      const localUrl = `${window.location.origin}/#/printInstruction`;
      const url = process.env.NODE_ENV === "production" ? serverUrl : localUrl;
      iframe.value.src = url;
    };

    // 批量打印
    const handleBatchPrint = async () => {
      const data = await getInstruction();
      if (data) {
        const list = [];

        Object.keys(data).forEach((key) => {
          list.push(...data[key]);
        });

        const newRecord = list.filter(
          (f) => selectedRowKeys.value.findIndex((r) => r === f.id) !== -1
        );

        console.log(newRecord, "f.id");

        if (newRecord.length > 0) {
          localStorage.setItem(
            "print-instruction-data",
            JSON.stringify([...newRecord])
          );
          toPrint();
        }
      }
    };

    const handlePrintInstruction = async (record) => {
      const data = await getInstruction();

      if (data) {
        const list = [];

        Object.keys(data).forEach((key) => {
          list.push(...data[key]);
        });

        const newRecord = list.find((f) => f.id === record.id);
        if (newRecord) {
          localStorage.setItem(
            "print-instruction-data",
            JSON.stringify(newRecord)
          );
          toPrint();
        }
      }
    };

    const handleActionClick = (e, record) => {
      const type = e.key;
      switch (type) {
        case "edit":
          handleInsertInstruction(null, record);
          break;
        case "print":
          handlePrintInstruction(record);
          break;
        default:
          break;
      }
    };
    // 更新表格
    const updateTable = (type) => {
      getData(type);
    };

    window.addEventListener("message", (e) => {
      if (e.type === "message" && e.data === "closeIframe") {
        iframe.value.src = "";
        iframe.value.style.display = "none";
      }
    });

    const init = () => {
      requestPayload.produceDate = timeStampToTime("", "upload");
      requestPayload.startDate = null;
      requestPayload.endDate = null;
      getData();
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === "instruction") {
          init();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      iframe,
      tableData,
      columns,
      rangeDate,
      instructionRef,
      getProcessName,
      requestPayload,
      productOption,
      produceOrTpc,
      selectedRowKeys,
      handleSelectRow,
      handleBatchPrint,
      handleSelectRangeDate,
      handleSelectDate,
      handleActionClick,
      updateTable,
      handleSearch,
      handlePrintInstruction,
      handleInsertInstruction,
    };
  },
});
</script>

<style lang="less" scoped>
.print-iframe {
  position: fixed;
  width: 1200px;
  height: 80%;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #000;
  box-shadow: 0 0 10px 0 #ccc;
  display: none;
}

.product-instruction-table {

  // height: calc(100vh - 300px);
  .toolip {
    margin-bottom: 20px;
  }
}
</style>
